import { CheckCircle2, PencilRuler } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { aboutMedia, motionMedia, materials, waLink } from "@/content/site";
import { Reveal, SectionHead, Arrow, RotatingBadge } from "@/components/apex/primitives";

const About = () => {
  const { t, isRtl } = useLang();
  return (
    <section id="about" data-testid="about-section" className="relative bg-[var(--cream-2)] py-14 sm:py-20">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <div className="relative mx-auto max-w-[560px] pb-[12%]" data-testid="about-collage">
            <div className="ap-img aspect-[4/5] w-[68%] !rounded-t-[999px]">
              <img
                src={aboutMedia.image}
                alt={isRtl ? aboutMedia.alt_ar : aboutMedia.alt_en}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="ap-img absolute bottom-0 end-0 aspect-[4/5] w-[58%] border-[6px] border-[var(--cream-2)]">
              <img
                src={motionMedia.image}
                alt={isRtl ? motionMedia.alt_ar : motionMedia.alt_en}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover"
                style={{ objectPosition: "45% 85%" }}
              />
            </div>
            <div className="absolute bottom-[6%] start-[26%]">
              <RotatingBadge text={t.nav.contact} href="#contact" testid="about-rotating-badge" />
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHead label={t.about.label} title={t.about.title} body={t.about.body} />

          <Reveal delay={0.1}>
            <div className="group mt-8 flex items-start gap-5 border-b border-[var(--line)] pb-7">
              <span className="ap-icon">
                <PencilRuler className="h-6 w-6" strokeWidth={1.7} />
              </span>
              <div>
                <h3 className="ap-display text-xl text-[var(--text)]">{t.manifesto.title}</h3>
                <p className="mt-2 text-[14px] leading-[1.8] text-[var(--muted)]">{t.about.caption}</p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.14}>
            <ul className="mt-7 grid gap-3 sm:grid-cols-2">
              {materials.map((m) => (
                <li key={m.id} className="ap-card flex items-center gap-3 px-5 py-4 text-[15px] font-semibold text-[var(--text)]">
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-[var(--yellow-dk)]" strokeWidth={2} />
                  {isRtl ? m.name_ar : m.name_en}
                </li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.18}>
            <a
              href={waLink(t.float.defaultMsg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-whatsapp"
              className="ap-btn mt-8"
            >
              {t.contact.wa}
              <Arrow />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
